import { SubscriptionsPage } from '@repo/ccc-main-app-lib/src/pages/SubscriptionsPage.tsx'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/user/$userId/subscriptions',
)({
  component: UserSubscriptionsPage,
})

function UserSubscriptionsPage() {
  const { userId } = Route.useParams()

  return <SubscriptionsPage userId={userId} />
}
